module.exports = __webpack_public_path__ + "static/img/modal-lucky-bag.a2cf089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/modal-lucky-bag.png
// module id = /9d5
// module chunks = 215